export default __webpack_public_path__ + "static/media/Update-resume.7405ccb9.pdf";